export default __webpack_public_path__ + "static/media/question-circle-solid.bf3b05ca.svg";